import Controller, { OnCancel, OnChange, OnMount, OnSubmit } from '@philips-internal/oswald-ui-core/lib/client';
import { FragmentNames, InformReasonArrivalAliases } from '../../codegen';
import BaseController from '../BaseController';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Inject } from '@odinjs/odin';
import { FieldAPI, ModalService } from '@philips-internal/oswald-ui-components';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';
import { ToastMsgUtils } from '../../utils/toastmsg-utils';
import { changePatientData } from '../../interfaces/change-patient/change-patient-data';

@Controller({ component: InformReasonArrivalAliases.LAYOUT_REASON, fragment: FragmentNames.INFORM_REASON_ARRIVAL})
export default class InformArrivalReasonController extends BaseController {

  @Inject(InformReasonArrivalAliases.FIELD_REASON)
  private readonly fieldReason!: FieldAPI;

  @OnMount({ target: InformReasonArrivalAliases.FIELD_REASON })
  onMountInput(): void {
    this.fieldReason.setValidators([{ name: 'required' }]);
  }

  @OnChange({ target: InformReasonArrivalAliases.AUTOCOMPLETE_REASON })
  onChange(event: ChangeEvent<Record<string, string>>): void {
    const selectedValue = event.value;
    if (selectedValue !== null && Number(selectedValue.reasonCode) > 0) {
      const reason = selectedValue.reasonCode;
      changePatientData.reasonCode = Number(reason);
      this.fieldReason.setValidators([]);
    } else {
      changePatientData.reasonCode = 0;
      this.fieldReason.setValidators([{ name: 'required' }]);
    }
  }

  @OnChange({ target: InformReasonArrivalAliases.FIELD_REASON_TEXT })
  onChangeTextArea(event: ChangeEvent<string>): void {
    const { value } = event;
    if (value) {
      changePatientData.reasonDescription = value;
    }
  }

  @OnSubmit({ target: InformReasonArrivalAliases.FORM_REASON })
  async onSubmit(): Promise<void> {

    const nrSeqLocalPa = changePatientData.sector;
    const { encounterId } = this.historyService.getCurrentRouteParams() as Record<string, number>;
    const { reasonCode, reasonDescription } = changePatientData;
    if (reasonCode > 0 && reasonDescription) {
      const parameters = {
        departmentEncounter: nrSeqLocalPa,
        encounterId: encounterId,
        generate: 'M',
        justification: reasonDescription,
        reasonCode: reasonCode,
      };
      HttpService.get(Endpoint.GENERATE_TRANSFER_CONFIRMATION, parameters).then((resp) => {
        const responseBody = resp.body as { STATUS: string };
        if (responseBody.STATUS === 'SUCESS2') {
          ToastMsgUtils.toastSucessMessage('msg.success', 'text.arrival_reason_registered');
          applicationContext.popNavigationItem();
          applicationContext.popNavigationItem();
        }
      }).catch(() => {
        ModalService.close('dialog-modal-service');
      }
      );
    }
  }

  @OnCancel({ target: InformReasonArrivalAliases.FORM_REASON })
  onCancel(): void {
    applicationContext.popNavigationItem();
  }
}
